import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Logo } from "../landing/Logo";
import { scrollToId } from "../landing/Navbar";

const PRODUCTS = [
  { label: "LearnNova", href: "#products" },
  { label: "CareerNova", href: "#products" },
  { label: "FoodNova", href: "#products" },
  { label: "ShopNova", href: "#products" },
  { label: "TravelNova", href: "#products" },
  { label: "LoanNova", href: "#loannova" },
  { label: "CommunityNova", href: "#community" },
];

const LINKS = [
  { label: "Home", href: "#top", testid: "nav-home" },
  { label: "Enterprise", href: "#enterprise", testid: "nav-enterprise" },
  { label: "Investors", href: "#investors", testid: "nav-investors" },
  { label: "Download App", href: "#download", testid: "nav-download" },
];

export const SiteNav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-nav"
      className="fixed inset-x-0 top-4 z-50 mx-auto w-[calc(100%-2rem)] max-w-6xl"
    >
      <nav className="flex items-center justify-between gap-4 rounded-full border border-white/10 bg-[#09090B]/80 py-3 pl-4 pr-3 backdrop-blur-2xl">
        <a href="#top" onClick={scrollToId("#top")} data-testid="site-nav-logo" className="flex items-center gap-2.5">
          <Logo className="h-8 w-8" />
          <span className="font-display text-lg font-extrabold tracking-[0.18em] text-white">
            FUNZ
          </span>
        </a>
        <div className="hidden items-center gap-6 lg:flex">
          {LINKS.slice(0, 1).map((l) => (
            <a key={l.href} href={l.href} data-testid={l.testid} onClick={scrollToId(l.href)} className="text-sm font-medium text-slate-400 transition-colors hover:text-white">
              {l.label}
            </a>
          ))}
          <div
            className="relative"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
          >
            <button
              data-testid="nav-products-dropdown"
              onClick={() => setOpen((o) => !o)}
              className="flex items-center gap-1.5 text-sm font-medium text-slate-400 transition-colors hover:text-white"
            >
              Products
              <ChevronDown className={`h-3.5 w-3.5 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
            </button>
            <div
              className={`absolute left-1/2 top-full w-56 -translate-x-1/2 pt-3 transition-all duration-200 ${
                open ? "visible opacity-100" : "invisible opacity-0"
              }`}
            >
              <div className="rounded-2xl border border-white/10 bg-[#111827]/95 p-2 shadow-2xl backdrop-blur-2xl">
                {PRODUCTS.map((p) => (
                  <a
                    key={p.label}
                    href={p.href}
                    data-testid={`nav-product-${p.label.toLowerCase()}`}
                    onClick={(e) => {
                      setOpen(false);
                      scrollToId(p.href)(e);
                    }}
                    className="block rounded-xl px-4 py-2.5 text-sm font-medium text-slate-300 transition-colors hover:bg-white/5 hover:text-[#00D26A]"
                  >
                    {p.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
          {LINKS.slice(1).map((l) => (
            <a key={l.href} href={l.href} data-testid={l.testid} onClick={scrollToId(l.href)} className="text-sm font-medium text-slate-400 transition-colors hover:text-white">
              {l.label}
            </a>
          ))}
        </div>
        <button
          data-testid="site-nav-cta"
          onClick={scrollToId("#claim")}
          className="glow-btn-z rounded-full bg-gradient-to-r from-[#635BFF] to-[#00D26A] px-5 py-2.5 font-display text-xs font-bold uppercase tracking-wider text-white"
        >
          Get Started
        </button>
      </nav>
    </header>
  );
};
